const GENIEBELT_API_URL = process.env.REACT_APP_GENIEBELT_API_URL!;
const SALESFORCE_PROVIVIENDA_URL = process.env.REACT_APP_SALESFORCE_PROVIVIENDA!;

const SALESFORCE_PROVIVIENDA_USER_EMAIL = 'integrations+sf_provivienda@letsbuild.com'
const SALESFORCE_PROVIVIENDA_USER_TEAM = 'LetsBuild Integrations'
const ENVIRONMENT = process.env.REACT_APP_ENV!;

export {
  GENIEBELT_API_URL,
  SALESFORCE_PROVIVIENDA_URL,
  SALESFORCE_PROVIVIENDA_USER_EMAIL,
  SALESFORCE_PROVIVIENDA_USER_TEAM,
  ENVIRONMENT
};
